// /data/fake-last-visited-products.ts
// ✅ Fake new arrival data
import { NewArrivalProduct } from "@/types/product"

function slugify(str: string): string {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
}

function generateUrl(name: string, modelNumber: string) {
  return `/${slugify(name)}/${modelNumber}.html`
}

function nowIso(offsetMs = 0) {
  return new Date(Date.now() - offsetMs).toISOString()
}

export const newArrivalProducts: NewArrivalProduct[] = [
  {
    product: {
      id: "1",
      title: "Soft Lux Mesh Full-Zip Hoodie",
      name: "Soft Lux Mesh Full-Zip Hoodie",
      description: "Soft Lux Mesh full-zip hoodie for daily comfort.",
      description_h5: "Soft Lux Mesh Full-Zip Hoodie",
      specifications: "Material: Mesh; Closure: Zip; Fit: Regular.",
      care: "Machine wash cold; Do not bleach.",
      gender: "Unisex",
      franchise: "Sportswear",
      product_type: "inline",
      brand: "Adidas",
      category: "Hoodie",
      sport: "Sportswear",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 70,
      compare_at_price: 90,
      installments: 12,
      created_at: nowIso(),
      updated_at: nowIso(),
      image: "/images/Soft_Lux_Mesh_Full-Zip_Hoodie_Beige_JV9858_000_plp_model.jpg",
      image_url: "/images/Soft_Lux_Mesh_Full-Zip_Hoodie_Beige_JV9858_000_plp_model.jpg",
      availableSizes: ["S", "M", "L", "XL"],
      collection: "Summer 2025",
      badge: "new",
      variants: [
        {
          id: "JV9858-WHT",
          color: "Beige",
          price: 70,
          compare_at_price: 90,
          sizes: ["S", "M", "L", "XL"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/Soft_Lux_Mesh_Full-Zip_Hoodie_Beige_JV9858_000_plp_model.jpg",
          available: true,
        },
      ],
      slug: slugify("Soft Lux Mesh Full-Zip Hoodie"),
      reviews_count: 18,
      average_rating: 4.4,
      url: generateUrl("Soft Lux Mesh Full-Zip Hoodie", "JV9858"),
      model_number: "JV9858",
    },
    timestamp: Date.now(),
    url: generateUrl("Soft Lux Mesh Full-Zip Hoodie", "JV9858"),
  },
  {
    product: {
      id: "2",
      title: "adicolor Firebird Oversized Track Pants",
      name: "adicolor Firebird Oversized Track Pants",
      description: "Classic Firebird track pants with an oversized fit.",
      description_h5: "adicolor Firebird Oversized Track Pants",
      specifications: "Material: Polyester; Fit: Oversized.",
      care: "Machine wash cold; Tumble dry low.",
      gender: "Unisex",
      franchise: "Originals",
      product_type: "inline",
      brand: "Adidas",
      category: "Pants",
      sport: "Originals",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 80,
      compare_at_price: 90,
      installments: 12,
      created_at: nowIso(1_000),
      updated_at: nowIso(1_000),
      image: "/images/adicolor_Firebird_Oversized_Track_Pants_Blue_JV7492_000_plp_model.jpg",
      image_url: "/images/adicolor_Firebird_Oversized_Track_Pants_Blue_JV7492_000_plp_model.jpg",
      availableSizes: ["XS", "S", "M", "L"],
      collection: "Summer 2025",
      badge: "best seller",
      variants: [
        {
          id: "JV7492-BLU",
          color: "Blue",
          price: 80,
          compare_at_price: 90,
          sizes: ["XS", "S", "M", "L"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/adicolor_Firebird_Oversized_Track_Pants_Blue_JV7492_000_plp_model.jpg",
          available: true,
        },
      ],
      slug: slugify("adicolor Firebird Oversized Track Pants"),
      reviews_count: 25,
      average_rating: 4.6,
      url: generateUrl("adicolor Firebird Oversized Track Pants", "JV7492"),
      model_number: "JV7492",
    },
    timestamp: Date.now() - 10_000,
    url: generateUrl("adicolor Firebird Oversized Track Pants", "JV7492"),
  },
  {
    product: {
      id: "3",
      title: "adicolor Teamgeist Cropped Track Top Blue",
      name: "adicolor Teamgeist Cropped Track Top Blue",
      description: "Cropped track top inspired by Teamgeist heritage.",
      description_h5: "adicolor Teamgeist Cropped Track Top Blue",
      specifications: "Material: Polyester; Fit: Cropped.",
      care: "Wash with like colors.",
      gender: "Women",
      franchise: "Originals",
      product_type: "inline",
      brand: "Adidas",
      category: "Top",
      sport: "Originals",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 70,
      compare_at_price: 90,
      installments: 12,
      created_at: nowIso(20_000),
      updated_at: nowIso(20_000),
      image: "/images/Teamgeist_Adicolor_Cropped_Track_Top_Blue_JZ8277_000_plp_model.jpg",
      image_url: "/images/Teamgeist_Adicolor_Cropped_Track_Top_Blue_JZ8277_000_plp_model.jpg",
      availableSizes: ["XS", "S", "M"],
      collection: "Summer 2025",
      badge: "new",
      variants: [
        {
          id: "JZ8277-BLU",
          color: "Blue",
          price: 70,
          compare_at_price: 90,
          sizes: ["XS", "S", "M"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/Teamgeist_Adicolor_Cropped_Track_Top_Blue_JZ8277_000_plp_model.jpg",
          available: true,
        },
      ],
      slug: slugify("adicolor Teamgeist Cropped Track Top Blue"),
      reviews_count: 9,
      average_rating: 4.3,
      url: generateUrl("adicolor Teamgeist Cropped Track Top Blue", "JZ8277"),
      model_number: "JZ8277",
    },
    timestamp: Date.now() - 20_000,
    url: generateUrl("adicolor Teamgeist Cropped Track Top Blue", "JZ8277"),
  },
  {
    product: {
      id: "4",
      title: "Adifom Stan Smith Mule Shoes",
      name: "Adifom Stan Smith Mule Shoes",
      description: "Slip-on Stan Smith mules for easy everyday wear.",
      description_h5: "Adifom Stan Smith Mule Shoes",
      specifications: "Upper: Synthetic; Outsole: EVA.",
      care: "Wipe with a damp cloth.",
      gender: "Unisex",
      franchise: "Originals",
      product_type: "inline",
      brand: "Adidas",
      category: "Shoes",
      sport: "Originals",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 70,
      compare_at_price: 90,
      installments: 12,
      created_at: nowIso(30_000),
      updated_at: nowIso(30_000),
      image: "/images/Adifom_Stan_Smith_Mule_Shoes_Blue_JR8820_00_plp_standard.jpg",
      image_url: "/images/Adifom_Stan_Smith_Mule_Shoes_Blue_JR8820_00_plp_standard.jpg",
      availableSizes: ["5", "6", "7", "8", "9"],
      collection: "Summer 2025",
      badge: "trending",
      variants: [
        {
          id: "JR8820-BLU",
          color: "Blue",
          price: 70,
          compare_at_price: 90,
          sizes: ["5", "6", "7", "8", "9"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/Adifom_Stan_Smith_Mule_Shoes_Blue_JR8820_00_plp_standard.jpg",
          available: true,
        },
      ],
      slug: slugify("Adifom Stan Smith Mule Shoes"),
      reviews_count: 31,
      average_rating: 4.5,
      url: generateUrl("Adifom Stan Smith Mule Shoes", "JR8820"),
      model_number: "JR8820",
    },
    timestamp: Date.now() - 30_000,
    url: generateUrl("Adifom Stan Smith Mule Shoes", "JR8820"),
  },
  {
    product: {
      id: "5",
      title: "Soft Lux Mesh Tee",
      name: "Soft Lux Mesh Tee",
      description: "Breathable mesh tee for lightweight comfort.",
      description_h5: "Soft Lux Mesh Tee",
      specifications: "Material: Mesh; Fit: Regular.",
      care: "Machine wash cold.",
      gender: "Women",
      franchise: "Originals",
      product_type: "inline",
      brand: "Adidas",
      category: "T-Shirt",
      sport: "Originals",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 35,
      compare_at_price: 90,
      installments: 12,
      created_at: nowIso(40_000),
      updated_at: nowIso(40_000),
      image: "/images/Soft_Lux_Mesh_Tee_Beige_JV9873_000_plp_model.jpg",
      image_url: "/images/Soft_Lux_Mesh_Tee_Beige_JV9873_000_plp_model.jpg",
      availableSizes: ["XS", "S", "M", "L"],
      collection: "Summer 2025",
      badge: "new",
      variants: [
        {
          id: "JV9873-BEI",
          color: "Beige",
          price: 35,
          compare_at_price: 90,
          sizes: ["XS", "S", "M", "L"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/Soft_Lux_Mesh_Tee_Beige_JV9873_000_plp_model.jpg",
          available: true,
        },
      ],
      slug: slugify("Soft Lux Mesh Tee"),
      reviews_count: 6,
      average_rating: 4.2,
      url: generateUrl("Soft Lux Mesh Tee", "JV9873"),
      model_number: "JV9873",
    },
    timestamp: Date.now() - 40_000,
    url: generateUrl("Soft Lux Mesh Tee", "JV9873"),
  },
  {
    product: {
      id: "6",
      title: "Superstar 82 Roller Skates",
      name: "Superstar 82 Roller Skates",
      description: "Retro-inspired roller skates with Superstar styling.",
      description_h5: "Superstar 82 Roller Skates",
      specifications: "Upper: Leather; Wheels: PU.",
      care: "Spot clean only.",
      gender: "Unisex",
      franchise: "Originals",
      product_type: "inline",
      brand: "Adidas",
      category: "Shoes",
      sport: "Originals",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 200,
      compare_at_price: 220,
      installments: 12,
      created_at: nowIso(40_000),
      updated_at: nowIso(40_000),
      image: "/images/Superstar_82_Roller_Skates_Black_JI3535_00_plp_standard.jpg",
      image_url: "/images/Superstar_82_Roller_Skates_Black_JI3535_00_plp_standard.jpg",
      availableSizes: ["6", "7", "8", "9"],
      collection: "Summer 2025",
      badge: "limited",
      variants: [
        {
          id: "JI3535-BLK",
          color: "Black",
          price: 200,
          compare_at_price: 220,
          sizes: ["6", "7", "8", "9"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/Superstar_82_Roller_Skates_Black_JI3535_00_plp_standard.jpg",
          available: true,
        },
      ],
      slug: slugify("Superstar 82 Roller Skates"),
      reviews_count: 11,
      average_rating: 4.1,
      url: generateUrl("Superstar 82 Roller Skates", "JI3535"),
      model_number: "JI3535",
    },
    timestamp: Date.now() - 40_000,
    url: generateUrl("Superstar 82 Roller Skates", "JI3535"),
  },
  {
    product: {
      id: "7",
      title: "Tiro Cut 3-Stripes Soft Mesh Long Dress",
      name: "Tiro Cut 3-Stripes Soft Mesh Long Dress",
      description: "Long dress with soft mesh and signature 3-Stripes.",
      description_h5: "Tiro Cut 3-Stripes Soft Mesh Long Dress",
      specifications: "Material: Polyester mesh; Fit: Slim.",
      care: "Machine wash cold.",
      gender: "Women",
      franchise: "Originals",
      product_type: "inline",
      brand: "Adidas",
      category: "Dress",
      sport: "Originals",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 60,
      compare_at_price: 90,
      installments: 12,
      created_at: nowIso(40_000),
      updated_at: nowIso(40_000),
      image: "/images/Tiro_Cut_3-Stripes_Soft_Mesh_Long_Dress_Burgundy_JX5160_000_plp_model.jpg",
      image_url: "/images/Tiro_Cut_3-Stripes_Soft_Mesh_Long_Dress_Burgundy_JX5160_000_plp_model.jpg",
      availableSizes: ["XS", "S", "M", "L"],
      collection: "Summer 2025",
      badge: "new",
      variants: [
        {
          id: "JX5160-BUR",
          color: "Burgundy",
          price: 60,
          compare_at_price: 90,
          sizes: ["XS", "S", "M", "L"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/Tiro_Cut_3-Stripes_Soft_Mesh_Long_Dress_Burgundy_JX5160_000_plp_model.jpg",
          available: true,
        },
      ],
      slug: slugify("Tiro Cut 3-Stripes Soft Mesh Long Dress"),
      reviews_count: 7,
      average_rating: 4.0,
      url: generateUrl("Tiro Cut 3-Stripes Soft Mesh Long Dress", "JX5160"),
      model_number: "JX5160",
    },
    timestamp: Date.now() - 40_000,
    url: generateUrl("Tiro Cut 3-Stripes Soft Mesh Long Dress", "JX5160"),
  },
  {
    product: {
      id: "8",
      title: "adidas Originals X Minecraft Jersey Kids",
      name: "adidas Originals X Minecraft Jersey Kids",
      description: "Kids jersey in collaboration with Minecraft.",
      description_h5: "adidas Originals X Minecraft Jersey Kids",
      specifications: "Material: Polyester; Fit: Regular.",
      care: "Machine wash cold.",
      gender: "Kids",
      franchise: "Originals",
      product_type: "inline",
      brand: "Adidas",
      category: "Jersey",
      sport: "Originals",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 40,
      compare_at_price: 50,
      installments: 12,
      created_at: nowIso(40_000),
      updated_at: nowIso(40_000),
      image: "/images/adidas_Originals_X_Minecraft_Jersey_Kids_Multicolor_KD9839_000_plp_model.jpg",
      image_url: "/images/adidas_Originals_X_Minecraft_Jersey_Kids_Multicolor_KD9839_000_plp_model.jpg",
      availableSizes: ["116", "128", "140", "152"],
      collection: "Summer 2025",
      badge: "kids",
      variants: [
        {
          id: "KD9839-MLT",
          color: "Multicolor",
          price: 40,
          compare_at_price: 50,
          sizes: ["116", "128", "140", "152"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/adidas_Originals_X_Minecraft_Jersey_Kids_Multicolor_KD9839_000_plp_model.jpg",
          available: true,
        },
      ],
      slug: slugify("adidas Originals X Minecraft Jersey Kids"),
      reviews_count: 5,
      average_rating: 4.2,
      url: generateUrl("adidas Originals X Minecraft Jersey Kids", "KD9839"),
      model_number: "KD9839",
    },
    timestamp: Date.now() - 40_000,
    url: generateUrl("adidas Originals X Minecraft Jersey Kids", "KD9839"),
  },
  {
    product: {
      id: "9",
      title: "Samba OG X Liberty London Shoes",
      name: "Samba OG X Liberty London Shoes",
      description: "Iconic Samba OG with Liberty London collaboration details.",
      description_h5: "Samba OG X Liberty London Shoes",
      specifications: "Upper: Leather; Outsole: Rubber.",
      care: "Wipe clean.",
      gender: "Unisex",
      franchise: "Originals",
      product_type: "inline",
      brand: "Adidas",
      category: "Shoes",
      sport: "Originals",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 105,
      compare_at_price: 120,
      installments: 12,
      created_at: nowIso(40_000),
      updated_at: nowIso(40_000),
      image: "/images/Samba_OG_X_Liberty_London_Shoes_White_JR8841_00_plp_standard.jpg",
      image_url: "/images/Samba_OG_X_Liberty_London_Shoes_White_JR8841_00_plp_standard.jpg",
      availableSizes: ["5", "6", "7", "8", "9", "10"],
      collection: "Summer 2025",
      badge: "collab",
      variants: [
        {
          id: "JR8841-WHT",
          color: "White",
          price: 105,
          compare_at_price: 120,
          sizes: ["5", "6", "7", "8", "9", "10"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/Samba_OG_X_Liberty_London_Shoes_White_JR8841_00_plp_standard.jpg",
          available: true,
        },
      ],
      slug: slugify("Samba OG X Liberty London Shoes"),
      reviews_count: 42,
      average_rating: 4.7,
      url: generateUrl("Samba OG X Liberty London Shoes", "JR8841"),
      model_number: "JR8841",
    },
    timestamp: Date.now() - 40_000,
    url: generateUrl("Samba OG X Liberty London Shoes", "JR8841"),
  },
  {
    product: {
      id: "10",
      title: "Samba OG Shoes",
      name: "Samba OG Shoes",
      description: "Timeless Samba OG with premium materials.",
      description_h5: "Samba OG Shoes",
      specifications: "Upper: Leather; Outsole: Rubber.",
      care: "Wipe clean.",
      gender: "Unisex",
      franchise: "Originals",
      product_type: "inline",
      brand: "Adidas",
      category: "Shoes",
      sport: "Originals",
      currencyId: "USD",
      currencyFormat: "$",
      isFreeShipping: true,
      price: 100,
      compare_at_price: 110,
      installments: 12,
      created_at: nowIso(40_000),
      updated_at: nowIso(40_000),
      image: "/images/Samba_OG_Shoes_White_JS1391_00_plp_standard.jpg",
      image_url: "/images/Samba_OG_Shoes_White_JS1391_00_plp_standard.jpg",
      availableSizes: ["5", "6", "7", "8", "9", "10"],
      collection: "Summer 2025",
      badge: "classic",
      variants: [
        {
          id: "JS1391-WHT",
          color: "White",
          price: 100,
          compare_at_price: 110,
          sizes: ["5", "6", "7", "8", "9", "10"],
          variant_code: "VC93-BL-b8e2",
          image_url: "/images/Samba_OG_Shoes_White_JS1391_00_plp_standard.jpg",
          available: true,
        },
      ],
      slug: slugify("Samba OG Shoes"),
      reviews_count: 58,
      average_rating: 4.8,
      url: generateUrl("Samba OG Shoes", "JS1391"),
      model_number: "JS1391",
    },
    timestamp: Date.now() - 40_000,
    url: generateUrl("Samba OG Shoes", "JS1391"),
  },
]
